import type { ChipProps } from "@mui/material";
import clsx from "clsx";
import { ChipStyled, classes } from "./styles";

export const RoundedChip = ({ className, ...props }: ChipProps) => {
  return <ChipStyled className={clsx(classes.root, className)} {...props} />;
};
